import { gql } from "@apollo/client";

export const FETCH_GEARS = gql`
  query FETCH_GEARS {
    products(productType: "marketing_gear") {
      total
      results {
        id
        name
        description
        imageUrls {
          id
          thumb: url(width: 300)
        }
        gearData
      }
    }
  }
`;

export const FETCH_GEAR_DETAIL = gql`
  query FETCH_GEAR_DETAIL($id: ID!) {
    product(id: $id) {
      id
      name
      description
      gearData
      imageUrls {
        id
        name
        url
        thumb: url(width: 300)
      }
    }
  }
`;

export const FETCH_GEAR_STOCKS = gql`
  query FETCH_GEAR_STOCKS($productIds: [ID!]!) {
    gearStocks(productIds: $productIds) {
      productId
      stocks {
        warehouseName
        qty
      }
    }
  }
`;

export const FETCH_GEAR_SHIPMENTS = gql`
  query FETCH_GEAR_SHIPMENTS($productId: ID!) {
    gearShipments(productId: $productId) {
      id
      qty
      shipment {
        id
        date
        warehouseName
        notes
      }
    }
  }
`;

export const CREATE_GEAR = gql`
  mutation CREATE_GEAR($name: String!) {
    createGear(name: $name) {
      product {
        id
        name
      }
    }
  }
`;

export const SAVE_GEAR = gql`
  mutation SAVE_GEAR($id: ID!, $imageUrls: [String!], $gearData: String) {
    saveGear(id: $id, imageUrls: $imageUrls, gearData: $gearData) {
      product {
        id
        name
        gearData
        imageUrls {
          id
          name
          url
          thumb: url(width: 300)
        }
      }
    }
  }
`;

export const SAVE_GEAR_SHIPMENT = gql`
  mutation SAVE_GEAR_SHIPMENT(
    $productId: ID!
    $warehouseName: String!
    $date: Date!
    $qty: Int!
    $notes: String
    $id: ID
    $delete: Boolean
  ) {
    saveGearShipment(
      productId: $productId
      warehouseName: $warehouseName
      date: $date
      qty: $qty
      notes: $notes
      id: $id
      delete: $delete
    ) {
      product {
        id
      }
    }
  }
`;

export const ARCHIVE_PRODUCT = gql`
  mutation ARCHIVE_PRODUCT($id: ID!) {
    archiveProduct(id: $id) {
      product {
        id
      }
    }
  }
`;
